import React from "react";

import twMerge from "@replo/design-system/utils/twMerge";
import Lottie from "lottie-react";

import loadingAnimation from "./reploading.json";

const loadingMessages = [
  "Adding in your custom content...",
  "Tidying up spacing and alignment...",
  "Syncing in your product data...",
];

const PreviewLoadingAnimation = ({ className }: { className?: string }) => {
  const [textIndex, setTextIndex] = React.useState(0);

  React.useEffect(() => {
    const interval = setInterval(() => {
      setTextIndex((textIndex) => (textIndex + 1) % loadingMessages.length);
    }, 4750);

    return () => clearInterval(interval);
  }, []);
  return (
    <div
      className={twMerge(
        "flex h-full w-full flex-col items-center justify-center gap-8 pt-[72px]",
        className,
      )}
    >
      <Lottie
        animationData={loadingAnimation}
        loop={true}
        className="z-10 w-[300px]"
      />
      <div className="text-muted text-center text-base">
        {loadingMessages[textIndex]}
      </div>
    </div>
  );
};

export default PreviewLoadingAnimation;
